export default __webpack_public_path__ + "static/media/LifeForce.32a87213.png";